module.exports = __webpack_public_path__ + "static/media/Screenshot_3.fc638b9a.png";